import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyDisplayService } from '../../_services/currency-display.service';
import { DataService } from '../../_services/data.service';
import { UserLocaleService } from '../../_services/user-locale.service';

@Pipe({
  name: 'localeCurrDisplay'
})
export class LocaleCurrencyDisplay implements PipeTransform {

  constructor(
    private localeService: UserLocaleService,
  ) {
  }

  transform(value: any, args?: any): any {
    return this.localeService.getLocaleFormattedAmount(value);
  }

}
